import domain from './domain';

// Restore AI Images
export const resetAiImages = domain.createEvent('resetAiImages');
